import { Box, Typography } from '@material-ui/core';
import { SText } from '@setvi/shared/components';
import { TextColor } from '@setvi/shared/enums';
import { OrderItemHistory } from '@setvi/shared/services/react-query/query/orders/types';
import moment from 'moment';
import {
  Cost,
  Price,
  Profit
} from 'pages/products/components/products-list/useProductColumns/contents';
import OrderStatus from 'pages/sales/modules/orders/components/order-status';

export const orderHistoryColumns = [
  {
    id: 'orderNumber',
    label: 'Order Number',
    width: '14%',
    cellContent: ({ erpOrderNumber }: OrderItemHistory) => {
      if (!erpOrderNumber) return '-';

      return (
        <Box>
          <Typography
            style={{
              display: 'inline-block',
              textDecoration: 'underline',
              color: TextColor.Blue,
              cursor: 'pointer'
            }}>
            {erpOrderNumber}
          </Typography>
        </Box>
      );
    }
  },
  {
    id: 'status',
    label: 'Status',
    width: '16%',
    cellContent: ({ status }: OrderItemHistory) => (
      <OrderStatus status={status} orderItem />
    )
  },
  {
    id: 'orderedOn',
    label: 'Ordered On',
    width: '14%',
    cellContent: (row: OrderItemHistory) => (
      <SText title={moment.utc(row.orderEffectiveDate).format('MM/DD/YYYY')} />
    )
  },
  {
    id: 'orderedQty',
    label: 'Ordered Qty',
    width: '12%',
    cellContent: ({ quantity }: OrderItemHistory) => (
      <SText title={quantity.toString()} />
    )
  },
  {
    id: 'sell',
    label: 'Sell',
    width: '14%',
    cellContent: ({ sell }: OrderItemHistory) => <Price value={sell} />
  },
  {
    id: 'cost',
    label: 'Cost',
    width: '14%',
    cellContent: ({ cost }: OrderItemHistory) => <Cost value={cost} />
  },
  {
    id: 'profit',
    label: 'Profit Margin',
    width: '16%',
    cellContent: ({ sell, cost }: OrderItemHistory) => (
      <Profit price={sell} cost={cost} />
    )
  }
];
